import './goal.style.sass';
import template from './goal.tpl.pug';

class GoalController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
        this.selectedGoals = [];
        this.goals = [
            {
                id: 'debt',
                title: 'Get Out of Debt',
                description: 'Take control of your debt and create a plan to become debt-free'
            },
            {
                id: 'savings',
                title: 'Build Savings',
                description: 'Create an emergency fund or save for big purchases'
            },
            {
                id: 'house',
                title: 'Buy a House',
                description: 'Save for a down payment and plan for homeownership'
            },
            {
                id: 'retirement',
                title: 'Plan Retirement',
                description: 'Prepare for a comfortable retirement and track investments'
            },
            {
                id: 'vacation',
                title: 'Travel & Vacation',
                description: 'Save for your dream vacation or travel adventures'
            },
            {
                id: 'car',
                title: 'Buy a Car',
                description: 'Save for a new car or manage car-related expenses'
            }
        ];
    }

    selectGoal(goal) {
        const index = this.selectedGoals.indexOf(goal);
        if (index === -1) {
            this.selectedGoals.push(goal);
        } else {
            this.selectedGoals.splice(index, 1);
        }
    }

    isSelected(goal) {
        return this.selectedGoals.includes(goal);
    }

    nextStep() {
        if (this.selectedGoals.length > 0) {
            this.onSubmit({
                questionKey: 'financial_goals',
                answer: this.selectedGoals.map((goal) => goal.id)
            });
            this.$state.go('conversion-quiz.suggestion');
        }
    }
}

export default {
    template: template(),
    controller: GoalController,
    bindings: {
        onSubmit: '&'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/goal/goal.cmpt.js